import React, { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Phone, MessageSquare } from 'lucide-react';

export const EmailLink: React.FC<{ email: string; className?: string }> = ({
  email,
  className = '',
}) => {
  if (!email) return null;

  return (
    <a
      href={`mailto:${email}`}
      className={`hover:text-confirmed-primary transition-colors hover:underline ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {email}
    </a>
  );
};

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  // If it has a 1 in front (e.g. US country code)
  const matchWithCountry = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
  if (matchWithCountry) {
    return `${matchWithCountry[1]}-${matchWithCountry[2]}-${matchWithCountry[3]}`;
  }
  return phoneNumberString;
};

export const PhoneLink: React.FC<{ phone: string; className?: string }> = ({
  phone,
  className = '',
}) => {
  if (!phone) return null;

  const formattedPhone = formatPhoneNumber(phone);

  return (
    <Menu
      as="div"
      className="relative inline-block text-left"
      onClick={(e: any) => e.stopPropagation()}
    >
      <Menu.Button
        as="button"
        className={`hover:text-confirmed-primary transition-colors hover:underline focus:outline-none ${className}`}
      >
        {formattedPhone}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute z-[1050] mt-2 w-32 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <a
                  href={`tel:${phone.replace(/\D/g, '')}`}
                  className={`${
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                  } group flex items-center px-4 py-2 text-sm`}
                >
                  <Phone
                    className="mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  Call
                </a>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <a
                  href={`sms:${phone.replace(/\D/g, '')}`}
                  className={`${
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                  } group flex items-center px-4 py-2 text-sm`}
                >
                  <MessageSquare
                    className="mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  Text
                </a>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
